import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { LocationProfileKeystore, LocationProfileResponse, LocationProfileWithLocationResponse } from '../types/location-profile';

@Injectable({
  providedIn: 'root',
})
export class LocationProfileService {
  private httpClient = inject(HttpClient);
  readonly apiHost = `${environment.apiBaseUrl}`;

  getLocationProfile(locationId: number): Observable<LocationProfileWithLocationResponse> {
    const requestUrl = `${this.apiHost}/Locations/${locationId}/Profile`;
    return this.httpClient.get<LocationProfileWithLocationResponse>(requestUrl);
  }

  // it does create or update logic
  patchLocationProfile(locationId: number, request: LocationProfileKeystore): Observable<LocationProfileResponse> {
    const requestUrl = `${this.apiHost}/Locations/${locationId}/Profile`;
    return this.httpClient.patch<LocationProfileResponse>(requestUrl, request);
  }
}
